/* ============================================================
   Rockson — section initializers
   Idempotent: safe to load multiple times.
   ============================================================ */
(function() {
  if (window.__rocksonInit) return;
  window.__rocksonInit = true;

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  onReady(function() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.rk .reveal, [data-rk-hero], [data-rk-reveal]').forEach(function(el) {
        el.classList.add('in', 'is-in');
      });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add('in');
        if (el.matches('[data-rk-hero]')) el.classList.add('is-in');
        observer.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    document.querySelectorAll('[data-rk-hero], [data-rk-reveal], .rk .reveal').forEach(function(el) {
      observer.observe(el);
    });
  });

  /* re-run when theme editor reloads a section */
  document.addEventListener('shopify:section:load', function(event) {
    if (!event.target.matches('.rockson-section, .shopify-section')) return;
    var scope = event.target;
    scope.querySelectorAll('[data-rk-hero], [data-rk-reveal], .rk .reveal').forEach(function(el) {
      el.classList.add('in');
      if (el.matches('[data-rk-hero]')) el.classList.add('is-in');
    });
  });
})();
